import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-rankings-create',
  templateUrl: './rankings-create.component.html',
  styleUrls: ['./rankings-create.component.scss']
})
export class RankingsCreateComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  headings = [];
  message = null;
  class = null;
  action = null;
  submitted = false;
  public rankingsForm: FormGroup;

  ngOnInit() {
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    
      // console.log(`${id}`);
      this.http.get<any>(this.api_endpoint+'/rankingsbyid/' + `${id}`).subscribe(
        data => {
          // console.log(data.data);
          if(data.data != null){
            this.action = 'Update';
            this.rankingsForm.patchValue({
              _id: data.data._id,
              heading: data.data.heading,
              image: data.data.image,
              description: data.data.description,
              link: data.data.link,
              seohidden: data.data.seohidden
            });
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    });

    this.http.get<any>(this.api_endpoint+'/rankingsheading').subscribe(
      data => {
        this.headings= data.data
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });

    this.rankingsForm = this.formBuilder.group({
      heading: ['', Validators.required],
      image: ['', Validators.required],
      description: [''],
      link: [''],
      _id: [''],
      seohidden: ['']
    })
  }


  
  get f() { return this.rankingsForm.controls; }

  onFormSubmit() {
    
    this.submitted = true;

    if (this.rankingsForm.invalid) {
      return;
    }

    if(this.action == 'Submit'){
    
    var data = {
      "description" : this.rankingsForm.value.description,
      "heading" : this.rankingsForm.value.heading,
      "headingname" : this.rankingsForm.value.headingname,
      "image" : this.rankingsForm.value.image,
      "link" : this.rankingsForm.value.link,
      "admin" : sessionStorage.getItem('adminName'),
      "seohidden" : this.rankingsForm.value.seohidden
    };
    // console.log(data);
    this.http.post<any>(this.api_endpoint+'/rankings', data).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/rankings/list-page');
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });
  }else{
    var data1 = {
      "description" : this.rankingsForm.value.description,
      "heading" : this.rankingsForm.value.heading,
      "headingname" : this.rankingsForm.value.headingname,
      "image" : this.rankingsForm.value.image,
      "link" : this.rankingsForm.value.link,
      "admin" : sessionStorage.getItem('adminName'),
      "_id" : this.rankingsForm.value._id,
      "seohidden" : this.rankingsForm.value.seohidden
    };
      // console.log(data1);     
      this.http.put<any>(this.api_endpoint+'/rankings/', data1).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/rankings/list-page');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
  }
  }

}
